import React,{ useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Nav from './common/Navigation';
import Header from './common/Header';
import Post from './common/Post'; 
import PostFeed from './common/PostFeed'; 
import Meow from './common/Meow'; 

export default function Feed({titleHead}){
	let navigate = useNavigate();
	
	useEffect(() => {
		let authToken = sessionStorage.getItem("Auth Token");
		
		if(authToken){
			navigate('/home')
		}
		
		if(!authToken){
			navigate('/')
		}
	}, [])
	
	return(
		<>
			<Header titleHead={titleHead}/>
			<Meow />
			<main>
				<PostFeed />
				<PostFeed />
			</main>
			<Nav />
		</>
	);
}